import React, { useCallback } from "react";
import { useProviderComparePageContext } from "../Context/ProviderComparePageContext";
import { ProviderInfoNav } from "./ProviderInfoNav";

import { event as backToSearchEvent } from "../GA/ProviderInfo/BackToSearch";
import { event as compareToAnotherProvider } from "../GA/ProviderInfo/CompareToAnotherProvider";

export const ProviderCompareNavWithContext = () => {
    const { loading, provider, toProvider } = useProviderComparePageContext();

    const onCompareButtonClick = useCallback(() => {
        compareToAnotherProvider("providerComparison", provider?.name);
    }, [provider]);

    const onBackToSearch = useCallback(() => {
        backToSearchEvent("providerComparison");
    }, []);

    return (
        <ProviderInfoNav
            provider={provider}
            toProvider={toProvider}
            loading={loading}
            onBackToSearch={onBackToSearch}
            onCompareButtonClick={onCompareButtonClick}
        />
    );
};
